import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'aa-headband',
    templateUrl: './headband.component.html',
    styleUrls: [
        './headband.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeadbandComponent
{
    @Input() label: string;
}
